import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class CircleEffect extends XYEffect {
	static key = "CircleEffect";
	constructor(xy: XY) {
		super(xy);
	}
}
